import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home, About, Publications, Dashboard, Login, Contact, Elec, OtherModeling, Privacy, SignUp, Solar, SolarSignUp, SolarLogin, SolarPremium, SolarSubscribe } from "./pages"
import { Article1, Article3, Article4, Article5, Article7, Article8, Article9, Article10, Article11, Article12, Article13} from "./pages/Publications/free"
import { Premarticle1, Premarticle2, Premarticle3, Premarticle4, Premarticle5, Premarticle6, Premarticle7, Premarticle8, Premarticle9, Premarticle10, Premarticle11, Premarticle12, Premarticle13, Premarticle14, Premarticle15, Premarticle16} from "./pages/Publications/premium"
import ScrollToTop from "./setup/ScrollToTop";
import PrivateRoutes from "./setup/PrivateRoutes"
import SolarRoutes from './setup/SolarRoutes';
import { AuthProvider } from './setup/AuthContext';
import ReactGA from 'react-ga4';
import { AuthProviderSolar } from './setup/AuthContextSolar';



ReactGA.initialize('G-PT227L1NZC');

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AuthProviderSolar>
          <BrowserRouter>
            <ScrollToTop>
            <Routes>
              <Route exact path="/" element={<Home />}/>
              <Route exact path="/Publications" element={<Publications />}/>
              <Route exact path="/Article1" element={<Article1 />}/>
              <Route exact path="/Article3" element={<Article3 />}/>
              <Route exact path="/Article4" element={<Article4 />}/>  
              <Route exact path="/Article5" element={<Article5 />}/>
              <Route exact path="/Article7" element={<Article7 />}/>
              <Route exact path="/Article8" element={<Article8 />}/>
              <Route exact path="/Article9" element={<Article9 />}/>
              <Route exact path="/Article10" element={<Article10 />}/>
              <Route exact path="/Article11" element={<Article11 />}/>
              <Route exact path="/Article12" element={<Article12 />}/>
              <Route exact path="/Article13" element={<Article13 />}/>
              <Route exact path="/About-Us" element={<About />}/>
              <Route exact path="/Contact-Us" element={<Contact />}/>
              <Route exact path="/Client-Login" element={<Login />}/>
              <Route exact path="/Client-SignUp" element={<SignUp/>}/>
              <Route exact path="/Electricity-Market-Modeling" element={<Elec />}/>
              <Route exact path="/Other-Modeling" element={<OtherModeling />}/>
              <Route exact path="/Privacy-Policy" element={<Privacy />}/> 
              <Route exact path="/Solar" element={<Solar />}/>
              <Route exact path="/Create-Solar-Account" element={<SolarSignUp />}/>
              <Route exact path="/Solar-Login" element={<SolarLogin />}/>
                              <Route exact path="/Solar-Subscribe" element={<SolarSubscribe />}/>
              <Route element={<SolarRoutes />}>
                <Route exact path="/Premium-Solar-Calculator" element={<SolarPremium/>}/>
              </Route>
              
              <Route element={<PrivateRoutes />}>
                <Route exact path="/Dashboard" element={<Dashboard />} />
                <Route exact path="/Premarticle1" element={<Premarticle1 />}/>
                <Route exact path="/Premarticle2" element={<Premarticle2 />}/>
                <Route exact path="/Premarticle3" element={<Premarticle3 />}/> 
                <Route exact path="/Premarticle4" element={<Premarticle4 />}/> 
                <Route exact path="/Premarticle5" element={<Premarticle5 />}/> 
                <Route exact path="/Premarticle6" element={<Premarticle6 />}/>  
                <Route exact path="/Premarticle7" element={<Premarticle7 />}/>  
                <Route exact path="/Premarticle8" element={<Premarticle8 />}/>
                <Route exact path="/Premarticle9" element={<Premarticle9 />}/>
                <Route exact path="/Premarticle10" element={<Premarticle10 />}/>
                <Route exact path="/Premarticle11" element={<Premarticle11 />}/>
                <Route exact path="/Premarticle12" element={<Premarticle12 />}/>
                <Route exact path="/Premarticle13" element={<Premarticle13 />}/>
                <Route exact path="/Premarticle14" element={<Premarticle14 />}/>
                <Route exact path="/Premarticle15" element={<Premarticle15 />}/>
                <Route exact path="/Premarticle16" element={<Premarticle16 />}/>             
              </Route>
            </Routes>
            </ScrollToTop>
        </BrowserRouter>
        </AuthProviderSolar>
      </AuthProvider>
    </div>
  );
}

export default App;
    